import { language2currencyMap, RegionFixedExchangeRateValue } from 'services/config/region';
import { DashboardCurrencyCtx } from '../ImplementData/hooks/useCurrency';
import { useEffect, useState } from 'react';
import { useTranslate } from '@tolgee/react';
import { RobotReply } from './RobotReply';
import { useSystemLanguageValue } from 'hooks/business/system/useSystem';

export const AIReplyDashboard = () => {
  const [currency, setCurrency] = useState<RegionFixedExchangeRateValue>();
  const [dataUpdateTime, setDataUpdateTime] = useState<string>();
  const { t } = useTranslate();

  const lang = useSystemLanguageValue();
  useEffect(() => {
    const next = language2currencyMap[lang];
    setCurrency(next);
  }, [lang]);

  return (
    <DashboardCurrencyCtx.Provider
      value={{
        currency,
        onChange: setCurrency,
        dataUpdateTime,
        setDataUpdateTime,
      }}
    >
      <div className="px-[16px] py-[17px] leading-[22px] flex border-solid border-0 border-b border-[#f0f0f0] bg-[#ffffff] mt-[16px]">
        <div className="text-[16px] leading-[22px] text-[#232426] font-medium">{t('AI问答')}</div>
      </div>
      <RobotReply />
    </DashboardCurrencyCtx.Provider>
  );
};
